(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/shared/info.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/shared/info.js');
"use strict";


const {
  createContext
} = React;
const InfoContext = createContext();
setGlobal('svs.eInstant.shared.info.InfoContext', InfoContext);
const InfoProvider = _ref => {
  let {
    children,
    gameUrl
  } = _ref;
  return React.createElement(InfoContext.Provider, {
    value: {
      game: svs.eInstant.data.gameConfigs.find(gameConfig => gameConfig.url === gameUrl)
    }
  }, children);
};
setGlobal('svs.eInstant.shared.info.InfoProvider', InfoProvider);
const Info = _ref2 => {
  let {
    onClose,
    show = false
  } = _ref2;
  const {
    Wrapper,
    Background,
    Content
  } = svs.eInstant.shared.info;
  return React.createElement(Wrapper, {
    onClose: onClose,
    show: show
  }, React.createElement(Background, null), React.createElement(Content, null));
};
setGlobal('svs.eInstant.shared.info.Info', Info);

 })(window);